<template>
  <vs-popup
    class="create-other-supplier-user-popup"
    id="popup"
    title="CREATE OTHER SUPPLIER USER"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onClickCreateSupplierUser)"
          autocomplete="off"
        >
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider
                vid="title"
                name="title"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Title</small>
                <v-select
                  :clearable="false"
                  placeholder=""
                  v-model="createForm.title"
                  :reduce="(option) => option"
                  :options="['Mr.', 'Mrs.', 'Miss']"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider
                vid="first_name"
                name="first_name"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">First Name</small>
                <vs-input
                  v-model="createForm.first_name"
                  name="first_name"
                  class="w-full required"
                  label=""
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider
                vid="last_name"
                name="last_name"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Last Name</small>
                <vs-input
                  v-model="createForm.last_name"
                  class="w-full"
                  name="last_name"
                  type="text"
                  label=""
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider
                vid="email"
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <small class="label">Email</small>
                <vs-input
                  v-model="createForm.email"
                  name="email"
                  class="w-full required"
                  label=""
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider
                vid="role"
                name="role"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Nimble User Role</small>
                <v-select
                  :clearable="false"
                  placeholder=""
                  v-model="createForm.types"
                  :options="customer_user_types"
                  multiple
                  :reduce="(option) => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  label="name"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2"
              >Save Changes</vs-button
            >
            <vs-button class="ml-4 mt-2" type="border" color="warning"
              >Reset</vs-button
            >
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const OtherSupplierRepository = RepositoryFactory.get("other_supplier");
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";

import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

function initialState() {
    return {
      createForm: {
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        types: [],
      },
      updateMode: false,
      open: false,
    };
}

export default {
  name: "createOtherSupplierUserPopUp",
  data() {
    return initialState()
    
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    ...mapActions(["fetchCustomerUserTypes"]),
    async openPopup(data = null) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        if (data !== null) {
          this.setInitialUpdateData(data)
          this.updateMode = true;
        }
        await this.fetchCustomerUserTypes();
        this.open = true;
      } catch (error) {}
    },

    setInitialUpdateData(data){
        const payload = {
            id: data.id,
            title: data.title,
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            types: data.types.map(x => x.id),
        }
        this.createForm = {...payload}
    },

    async onClickCreateSupplierUser() {
      const vue = this;
      this.$vs.loading();
      try {
        const payload = {
          ...this.createForm,
          supplier_id: this.$route.params.id,
        };
        if (!this.updateMode) {
          await OtherSupplierRepository.createOtherSupplierUser(payload);
          this.showSuccessMessage("New supplier user created successfully");
        } else {
          await OtherSupplierRepository.updateOtherSupplierUser(
            this.createForm.id,
            payload
          );
          this.showSuccessMessage("New supplier user updated successfully");
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close();
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters(["customer_user_types"]),
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
